import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-list-activites',
  templateUrl: './list-activites.component.html',
  styleUrls: ['./list-activites.component.scss']
})
export class ListActivitesComponent implements OnInit {
  @Input() listActivities;
  data = [{
    id: 1,
    color: 'uno',
    description: 'Mkt',
    activity: [
      {
        description: 'Add New Person, Luis Rojas',
        responsable: 'Administrador',
        created: 'Mar, 25 2019 14:55',
        status: 'DONE'
      },
      {
        description: 'Add New Dificult',
        responsable: 'Maria Perez',
        created: 'Mar, 27 2019 12:20',
        status: 'IN PROCESS'
      }
    ]
  },
  {
    id: 2,
    color: 'dos',
    description: 'Tecnología',
    activity: [
      {
        description: 'Add New Person, Luis Rojas',
        responsable: 'Administrador',
        created: 'Mar, 25 2019 14:55',
        status: 'DONE'
      },
      {
        description: 'Add New Dificult',
        responsable: 'Maria Perez',
        created: 'Mar, 27 2019 12:20',
        status: 'ADD'
      },
      {
        description: 'Delete New Dificult',
        responsable: 'Luis Rodriguez',
        created: 'Mar, 27 2019 12:20',
        status: 'DELETE'
      },
      {
        description: 'Add New Solution',
        responsable: 'Luis Rodriguez',
        created: 'Mar, 27 2019 12:20',
        status: 'ADD'
      }
    ]

}];
  portafolioName: any;
  icon: string;
  listActivities2;
  mostrar: any;
  constructor(activateRoute: ActivatedRoute) {
    this.portafolioName = activateRoute.snapshot.params['id'];
   }

  ngOnInit() {
    this.icon="fa fa-angle-right float-right mr-20";
    this.listActivities2= this.data;
    this.mostrarLista()
  }
  mostrarLista(){
    if (this.portafolioName){
      this.mostrar= true;
      console.log(this.mostrar);
    }else{
      this.mostrar= false;
      console.log(this.mostrar);
    }
  }
  changeIcon(){
    switch (this.icon) {
      case "fa fa-angle-right float-right mr-20":
        this.icon="fa fa-angle-down float-right mr-20";
      break;
      case "fa fa-angle-down float-right mr-20":
          this.icon="fa fa-angle-right float-right mr-20";
      break;
    }
  }
}
